import { render, staticRenderFns } from "./InfoMain.vue?vue&type=template&id=e24e345c&scoped=true&"
import script from "./InfoMain.vue?vue&type=script&lang=js&"
export * from "./InfoMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e345c",
  null
  
)

export default component.exports